export default "__VITE_ASSET__c8452913__"